import api from "../../utils/appApi";
import {__loco} from "../../utils/localization";

/**
 * Payment handler
 */
export class CheckoutPayment {
  /**
   * Bootstrap instance
   */
  constructor(params = {}) {

    /**
     * Params may include
     *
     * callbacks: {
     *   stripeValidationError(error)
     *   stripeValidationSuccess(...)
     * }
     */
    this.params = params;

    /**
     * Set initial state
     * @type {{stripeKey: null, elements: null, stripe: null, card: null}}
     */
    this.state = {
      /**
       * Stripe key which will be used for stripe requests.
       */
      stripeKey: null,

      /**
       * Stripe API Wrapper
       */
      stripe: null,

      /**
       * Stripe elements
       */
      elements: null,

      /**
       * Stripe card
       */
      card: null,
    };

    /**
     * Stripe basic config
     */
    this.stripeConfig = {
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    };

    /**
     * Component-level selectors
     * @type {{cardPlaceholder: string, cardholderName: string, confirmBtn: string}}
     */
    this.selectors = {
      cardPlaceholder: '#card-element',
      cardholderName: '#holder',
      confirmBtn: '#confirm-button'
    };

    /**
     * Adjust selectors for mobile
     */
    if($(window).width() < 760) {
      //@todo: Remove mobile dependency.
      // this.selectors = {
      //   cardPlaceholder: '#mobile-card-element',
      //   cardholderName: '#mobile-holder',
      //   confirmBtn: '#mobile-checkout-confirm-btn'
      // };
    }

  }

  /**
   * Get stripe payment key
   */
  initialize() {
    api.public.checkout
      .getStripeKey({})
      .then((response) => {
        this.state.stripeKey = response.data.data.stripeKey;
        this.initializeStripe();
      })


  }

  /**
   * Check if stripe key is set
   *
   * @returns {boolean}
   */
  isPaymentKeySet() {
    return this.state.stripeKey !== null;
  }

  /**
   * Get stripe key
   * @returns {null}
   */
  getStripeKey() {
    return this.state.stripeKey;
  }

  /**
   * get stripe card
   */
  getCard() {
    return this.state.card;
  }

  /**
   * Get stripe
   */
  getStripe() {
    return this.state.stripe;
  }

  /**
   * get elements
   */
  getElements() {
    return this.state.elements;
  }

  /**
   * Initialize stripe
   */
  initializeStripe() {

    const self = this;

    this.state.stripe = new Stripe(this.getStripeKey());
    this.state.elements = this.getStripe().elements();
    this.state.card = this.getElements().create('card');
    let isCardDataIsValid = false;
    let isTermsAndConditionIsChecked = false;
    // mount card
    this.getCard().mount(this.selectors.cardPlaceholder);

    // Handle real-time validation errors from the card Element.
    this.getCard().addEventListener('change', function (event) {
      console.log(event)

      let displayError = document.getElementById('card-errors');

      if(!event.error && !event.complete) {
        displayError.textContent = __loco('Your card number is incomplete.')
        if(typeof self.params.callbacks.stripeValidationError !== "undefined" ) {
          self.params.callbacks.stripeValidationError(event.error);
        }
      }else if (event.error) {

        /**
         * Run callback for stripe validation error
         */
        if(typeof self.params.callbacks.stripeValidationError !== "undefined" ) {
          self.params.callbacks.stripeValidationError(event.error);
        }

        /**
         * Display the error on UI
         */
        displayError.textContent = event.error ? event.error.message : '';
        document.querySelector('.checkoutPageLoader').classList.add('hideFullScreenLoader');

      } else {

        /**
         * If input is empty - trigger the callback
         */
        if(event.empty && typeof self.params.callbacks.stripeValidationEmpty !== "undefined" ) {
          self.params.callbacks.stripeValidationEmpty();
        }

        /**
         * Run callback for stripe validation success
         */
        if(typeof self.params.callbacks.stripeValidationSuccess !== "undefined" && event.complete) {
          isCardDataIsValid = true;
          self.checkIfDetailIsValid(isTermsAndConditionIsChecked, isCardDataIsValid)
        }

        /**
         * Clear errors from UI
         */
        displayError.textContent = '';
      }
    });


    document.getElementById('checkOutTermsCondition').addEventListener('change',(event) => {
      isTermsAndConditionIsChecked = event.target.checked;
      this.checkIfDetailIsValid(isTermsAndConditionIsChecked, isCardDataIsValid);
    })
    
    document.getElementById('holder').addEventListener('input',(event) => {
      this.checkIfDetailIsValid(isTermsAndConditionIsChecked, isCardDataIsValid);
    })
  }

  checkIfDetailIsValid(isTermsAndConditionIsChecked, isCardDataIsValid) {
    let cardHolderName = document.getElementById('holder').value;
    if(cardHolderName && isTermsAndConditionIsChecked && isCardDataIsValid) {
      this.params.callbacks.stripeValidationSuccess();
    } else {
      // this.params.callbacks.stripeValidationEmpty();
    }
  }

  /**
   * Initialize payment
   * @param {{ clientSecret: String, cardHolderName: String, orderResponse: Object, responseCallback: CallableFunction }} config
   */
  initializePayment(config)
  {
    let cardHolderName = config.cardHolderName;
    let clientSecret = config.clientSecret;

    this.getStripe().handleCardPayment(
      clientSecret, this.getCard(), {
        payment_method_data: {
          billing_details: {
            name: cardHolderName
          }
        }
      }
    ).then(function (result) {
      if(typeof config.responseCallback !== "undefined") {
        config.responseCallback(result);
      }
    });
  }

  /**
   * @todo: Check usage
   * @param token
   */
  stripeTokenHandler(token) {
    // Insert the token ID into the form so it gets submitted to the server
    let form = document.getElementById('payment-form');
    let hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.setAttribute('name', 'stripeToken');
    hiddenInput.setAttribute('value', token.id);
    form.appendChild(hiddenInput);

    // Submit the form
    form.submit();
  }
}
